<template>
<div class="chapter">
<div class="inner_page">
<h2 class="title"><a id="page_iii"></a>ENGLISH REBELS AND REVOLUTIONARIES</h2>
<p class="author">STEPHEN BASDEO</p>
<p class="author1">WITH ESSAYS BY ANNE ANDERSON, STEPHEN BASDEO, DI DRUMMOND, <br/>ANGELO CALFO, FRANCES CHIU, SHELDON GOLDFARB, ALEXANDER <br/>KAUFMAN, REBECCA NESVET, SAM QUILL, AND JOSEPH SAUNDERS</p>
<div class="img_container3">
<img alt="images" src="images/fiii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?64b2907a